export class EditAdvertisingSettingsDto {
    facebookMarketingToken!: string;
}